import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await signIn(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f9f9fb' }}>
      <div className="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="text-center">
            <img 
              src="/assets/logo---dark-with-color.png" 
              alt="Remote Assistant" 
              className="mx-auto h-12 w-auto mb-4"
            />
            <h2 className="text-3xl font-montserrat font-semibold" style={{ color: '#222324' }}>
              Admin Portal
            </h2>
            <p className="mt-2 text-sm font-inter" style={{ color: '#979ba4' }}>
              Sign in to manage Remote Assistant
            </p>
          </div>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow-sm" style={{ borderRadius: '16px', border: '1px solid #e5e7eb' }}>
            <form className="space-y-6" onSubmit={handleSubmit}>
              {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3" style={{ borderRadius: '8px' }}>
                  <div className="font-inter text-sm">{error}</div>
                </div>
              )}

              <div>
                <label htmlFor="email" className="block text-sm font-inter font-medium" style={{ color: '#979ba4' }}>
                  Email address
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="appearance-none block w-full px-3 py-2 border font-inter text-sm"
                    style={{ 
                      borderColor: '#e5e7eb',
                      borderRadius: '8px',
                      color: '#222324'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#055efd'}
                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-inter font-medium" style={{ color: '#979ba4' }}>
                  Password
                </label>
                <div className="mt-1">
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="appearance-none block w-full px-3 py-2 border font-inter text-sm"
                    style={{ 
                      borderColor: '#e5e7eb',
                      borderRadius: '8px',
                      color: '#222324'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#055efd'}
                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full btn-primary disabled:opacity-50"
                >
                  {loading ? 'Signing in...' : 'Sign in'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;